import { render, staticRenderFns } from "./TableUnitsMeasure.vue?vue&type=template&id=2ca31b21"
import script from "./TableUnitsMeasure.vue?vue&type=script&lang=js"
export * from "./TableUnitsMeasure.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports